import { CaretDownFilled } from "@ant-design/icons";
import { Button, type MenuProps, Skeleton } from "antd";
import { createStyles } from "antd-style";

import { Dropdown } from "@av/components/atoms/Dropdown";

import type { AppSwitcherEntry } from "../type";

const useStyles = createStyles(({ css, token }) => ({
  button: css`
    width: max-content;
    min-width: 150px;
    white-space: nowrap;
    border-color: ${token.colorPrimary};
    color: ${token.colorPrimary};
  `,
  placeHolder: css`
    height: 30px;
    opacity: 80%;
  `,
}));

interface AppSwitcherProps {
  apps: AppSwitcherEntry[];
  currentApp: string;
  onAppChange?: (app: string) => void;
}

export function AppSwitcher({ apps = [], currentApp, onAppChange }: AppSwitcherProps) {
  const { styles } = useStyles();

  const items = apps.map(({ path, name, icon }) => ({
    key: path,
    label: name,
    icon: icon,
  }));

  const handleMenuClick: MenuProps["onClick"] = ({ key }) => {
    onAppChange?.(key);
  };

  const item = items.find((i) => i?.key === currentApp);

  return items.length === 0 ? (
    <Skeleton.Input className={styles.placeHolder} active size="default" />
  ) : (
    <Dropdown
      disabled={items.length < 2}
      testIdPrefix="app-switcher"
      menu={{ items, onClick: handleMenuClick }}
      placement="bottomLeft"
    >
      <Button className={styles.button} icon={item?.icon}>
        {item?.label}
        <CaretDownFilled />
      </Button>
    </Dropdown>
  );
}
